<template>
  <div class="header-child header-red">
    Outstanding Invoice
  </div>

  <div class="content-base">
    <div class="this-list" :class="valueOut.showAll === child.label ? '' : 'data-hide'" v-for="child in dataChild.value" :key="child.label">
      <div class="child-name">
        <p>{{ child.label }}</p>
      </div>

      <div v-if="dataOut.value">
        <div class="data-list" :class="out.name_siswa === child.label ? 'padding-data' : ''" v-for="out in dataOut.value.filter(item => item.name_siswa === child.label)" :key="out.name_siswa" @click.capture="detailClickInv(out)">
          <div class="subject-time" :class="[out.due_date <= realdate ? 'data-danger' : '']">
            <p class="denger-text">{{ out.income_type_name }}</p>
            <p class="important-text">Rp {{ formatIdr(out.outstanding) }}</p>
            <p>{{ formatDate(out.invoice_date) }}</p>
          </div>
        </div>
      <!-- Button show all -->
        <div :class="out.name_siswa === child.label ? 'more-data' : ''" v-show="valueOut.showAll !== out.name_siswa && dataOut.value.filter(item => item.name_siswa === child.label).length > 1" v-for="out in dataOut.value" :key="out.name_siswa">
          <div class="btn-show-all" v-if="out.name_siswa === child.label && dataOut.value.filter(item => item.name_siswa === child.label).length > 1" @click="clickAll(out.name_siswa)">Show all</div>
        </div>
      </div>

      <!-- No data -->
      <div v-if="dataOut.value">
        <div class="nodata-list" v-if="dataOut.value.filter(item => item.name_siswa === child.label).length == 0">
          <p>No Data!</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Load data -->
  <div v-if="loadData === true" class="this-loader" :class="loadData === true ? 'lay-load' : ''">
    <data-loader />
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUpdated, watchEffect, watch, computed } from 'vue';
  import axios from 'axios'
  import dayjs from 'dayjs';

  import DataLoader from '../../../components/Animation/DataLoader.vue';

  export default {
    name: "Outstanding Preview",

    components: {
      DataLoader
    },

    data() {
      return {
        realdate: ""
      }
    },

    mounted() {
      setInterval(() => this.setTime(), 1000)
    },

    methods: {
      //  Format for date (1 January 2023)
      formatDate(dateString) {
        const date = dayjs(dateString);
        return date.format('D MMMM YYYY');
      },

      // Format IDR (2.000.000)
      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, "."),

      setTime() {
        const date = new Date();
        let years = date.getFullYear();
        let months = date.getMonth() + 1;
        let days = date.getDate();
        months = months <= 9 ? `${months}`.padStart(2, 0) : months;
        days = days <= 9 ? `${days}`.padStart(2, 0) : days;
        this.years = years;
        this.months = months;
        this.days = days;
        let realdate = years +  '-' + months + '-' +  days
        this.realdate = realdate;
      }
    },

    setup(props, {emit}) {
      // Get childern
      const method = 'GET'
      const url = 'parent-children'
      const value = reactive({
        parent_id: localStorage.getItem('user_id'),
        childern: "",
        nameyear: ""
      });
      const dataChild = reactive({})

      // Get payment
      const methodOut = 'GET'
      const urlOut = 'invoicetransaction-parent'
      const valueOut = reactive({
        category_id: "",
        department_id: "",
        financial_year_id: "",
        level_id: "",
        class_id: "",
        newbatch_id: "",
        candidatesgroup_id: "",
        user_parent: localStorage.getItem('user_id'),
        selectinv: false,
        date_all: true,
        showAll: ""
      });
      const dataOut = reactive({})

      // Get data childern
      const getChild = async () => {
        await axios({
            method,
            url,
            params: value
        })
        .then(response => {
          dataChild.value = response.data.data
          loadData.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      // Get data payment
      const getOut = async () => {
        await axios({
            method: methodOut,
            url: urlOut,
            params: valueOut
        })
        .then(response => {
          dataOut.value = response.data.data
          loadData.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      const detailClickInv = (event) => {
        emit("detail-click", event)
      }

      const clickAll = (data) => {
        valueOut.showAll = data
      }

      // Load data
      const loadData = ref(true)

      onMounted(() => {
        getChild()
        getOut()
      })

      return {
        detailClickInv,
        method,
        url,
        value,
        dataChild,
        methodOut,
        urlOut,
        valueOut,
        dataOut,
        loadData,
        // showAll,
        clickAll
      }
    }
  }
</script>

